import React, { useEffect, useState } from 'react'
import Layout from 'Layout'
import { useNavigate } from 'react-router-dom'
import { Modal as AntModal, Button } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import './styles.scss'

const Dashboard: React.FC = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleConfirm = () => {
    setOpen(true);
  };

  const handleHomepage = () => {
    setOpen(false);
    navigate("/"); // chuyển về trang chủ
  };

  return (
    <Layout>
      <div className='container flex justify-center flex-col items-center'>
        <div className="title-32-my-65-48">Membership Order</div>
        <div className="sm:w-[555px] sm:px-[40px] px-[16px] sm:py-[32px] w-100 py-[12px] bg-white border border-[#e5e7eb] rounded-md text-[#404654] font-[Inter] text-[14px] leading-[22px]">
          {/* Header */}
          <div className="flex items-center gap-4 mb-5">
            <div className="w-[64px] h-[64px] rounded-full bg-[#4A587C] flex items-center justify-center text-white text-[24px] font-semibold">
              V
            </div>
            <div>
              <div className="text-[24px] leading-[40px] font-semibold text-[#2E2E2E]">
                Vincent Chen
              </div>
              <div className="text-[#6B7280] leading-[24px] text-[16px]">
                vincent.chen@vcgroup.com
              </div>
            </div>
          </div>

          <hr className="border-[#E5E7EB] mb-6" />

          {/* Plan Info */}
          <div className="mb-6 text-[16px]">
            <div className="flex justify-between mb-[32px]">
              <span>Selected Plan</span>
              <span className="font-medium">Premium Plus</span>
            </div>
            <div className="flex justify-between mb-[32px]">
              <span>Plan Duration</span>
              <span>12 months</span>
            </div>
            <div className="flex justify-between mb-[32px]">
              <span>Plan Starts on</span>
              <span>01/02/2022</span>
            </div>
            <div className="flex justify-between mb-[32px]">
              <span>Plan Expires on</span>
              <span>14/02/2022</span>
            </div>
          </div>

          {/* Payment Section */}
          <div className="bg-[#F9F8F7] border border-[#E5E7EB] rounded-md p-4 mb-[32px] text-[16px]">
            <div className="flex justify-between items-center mb-[32px]">
              <span className="font-medium">Payment</span>
              <span className="text-[#6B7280] text-[15px] flex items-center">USD
                <div className="icon-svg">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_2077_129)">
                      <path d="M7 10L12 15L17 10H7Z" fill="white" />
                      <path d="M7 10L12 15L17 10H7Z" fill="black" fill-opacity="0.35" />
                    </g>
                    <defs>
                      <clipPath id="clip0_2077_129">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              </span>
            </div>
            <div className="flex justify-between pr-2 mb-[16px]">
              <span>Monthly Rate</span>
              <span>$5.00</span>
            </div>
            <hr className="border-[#E5E7EB] mb-[16px]" />
            <div className="flex justify-between pr-2">
              <span>Total Amount</span>
              <span>$60.00</span>
            </div>
          </div>

          <div className="flex justify-between mb-[32px] text-[16px]">
            <span>Payment Method</span>
          </div>

          <div className="flex justify-between mb-[32px] text-[16px]">
            <span className="text-[#6B7280] flex items-center">Credit | Debit Card</span>
            <span className="font-medium">
              <div className="icon-svg w-[232px] h-[40px] btn-border-C1A875-cl-C1A875 transition duration-300 flex justify-center items-center"
                onClick={handleConfirm}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_2088_136)">
                    <path d="M7 15H10C10.2652 15 10.5196 14.8946 10.7071 14.7071C10.8946 14.5196 11 14.2652 11 14C11 13.7348 10.8946 13.4804 10.7071 13.2929C10.5196 13.1054 10.2652 13 10 13H7C6.73478 13 6.48043 13.1054 6.29289 13.2929C6.10536 13.4804 6 13.7348 6 14C6 14.2652 6.10536 14.5196 6.29289 14.7071C6.48043 14.8946 6.73478 15 7 15ZM19 5H5C4.20435 5 3.44129 5.31607 2.87868 5.87868C2.31607 6.44129 2 7.20435 2 8V17C2 17.7956 2.31607 18.5587 2.87868 19.1213C3.44129 19.6839 4.20435 20 5 20H19C19.7956 20 20.5587 19.6839 21.1213 19.1213C21.6839 18.5587 22 17.7956 22 17V8C22 7.20435 21.6839 6.44129 21.1213 5.87868C20.5587 5.31607 19.7956 5 19 5ZM20 17C20 17.2652 19.8946 17.5196 19.7071 17.7071C19.5196 17.8946 19.2652 18 19 18H5C4.73478 18 4.48043 17.8946 4.29289 17.7071C4.10536 17.5196 4 17.2652 4 17V11H20V17ZM20 9H4V8C4 7.73478 4.10536 7.48043 4.29289 7.29289C4.48043 7.10536 4.73478 7 5 7H19C19.2652 7 19.5196 7.10536 19.7071 7.29289C19.8946 7.48043 20 7.73478 20 8V9Z" fill="currentColor" />
                    <path d="M7 15H10C10.2652 15 10.5196 14.8946 10.7071 14.7071C10.8946 14.5196 11 14.2652 11 14C11 13.7348 10.8946 13.4804 10.7071 13.2929C10.5196 13.1054 10.2652 13 10 13H7C6.73478 13 6.48043 13.1054 6.29289 13.2929C6.10536 13.4804 6 13.7348 6 14C6 14.2652 6.10536 14.5196 6.29289 14.7071C6.48043 14.8946 6.73478 15 7 15ZM19 5H5C4.20435 5 3.44129 5.31607 2.87868 5.87868C2.31607 6.44129 2 7.20435 2 8V17C2 17.7956 2.31607 18.5587 2.87868 19.1213C3.44129 19.6839 4.20435 20 5 20H19C19.7956 20 20.5587 19.6839 21.1213 19.1213C21.6839 18.5587 22 17.7956 22 17V8C22 7.20435 21.6839 6.44129 21.1213 5.87868C20.5587 5.31607 19.7956 5 19 5ZM20 17C20 17.2652 19.8946 17.5196 19.7071 17.7071C19.5196 17.8946 19.2652 18 19 18H5C4.73478 18 4.48043 17.8946 4.29289 17.7071C4.10536 17.5196 4 17.2652 4 17V11H20V17ZM20 9H4V8C4 7.73478 4.10536 7.48043 4.29289 7.29289C4.48043 7.10536 4.73478 7 5 7H19C19.2652 7 19.5196 7.10536 19.7071 7.29289C19.8946 7.48043 20 7.73478 20 8V9Z" fill="black" fill-opacity="0.06" />
                  </g>
                  <defs>
                    <clipPath id="clip0_2088_136">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </span>
          </div>

          <div className="flex justify-between mb-[32px] text-[16px]">
            <span className="text-[#6B7280] flex items-center">Paypal</span>
            <span className="font-medium">
              <div className="icon-svg w-[232px] h-[40px] btn-border-C1A875-cl-C1A875 transition duration-300 flex justify-center items-center"
                onClick={handleConfirm}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_2088_125)">
                    <path d="M20.4369 7.10449C20.2642 6.91091 20.0723 6.7354 19.8641 6.58069C19.9495 5.91079 19.8905 5.23035 19.6908 4.58522C19.4911 3.9401 19.1554 3.34527 18.7064 2.84082C17.6224 1.61914 15.7748 1 13.2142 1H7.00035C6.55143 1.0012 6.11755 1.16195 5.77623 1.45354C5.43491 1.74514 5.20836 2.14858 5.13707 2.5918L2.54722 18.9981C2.51058 19.218 2.52233 19.4432 2.58167 19.6581C2.64101 19.873 2.74649 20.0724 2.89078 20.2423C3.03507 20.4123 3.21468 20.5487 3.4171 20.6421C3.61952 20.7355 3.83988 20.7837 4.06282 20.7832H6.72691L6.64491 21.3037C6.61175 21.5131 6.62436 21.7272 6.68189 21.9312C6.73941 22.1352 6.84047 22.3244 6.97811 22.4856C7.11576 22.6468 7.28671 22.7763 7.4792 22.8651C7.67168 22.9539 7.88113 22.9999 8.09312 23H11.3275C11.7465 23.0033 12.1529 22.8572 12.4739 22.5878C12.7948 22.3185 13.0092 21.9435 13.0785 21.5303L13.7191 17.499L13.7299 17.4443H14.0287C18.0609 17.4443 20.5795 15.4512 21.3139 11.6816C21.5379 10.9035 21.5752 10.0835 21.4229 9.28817C21.2705 8.49287 20.9327 7.74472 20.4369 7.10449ZM7.84215 13.7041L7.12767 18.2394L7.04136 18.7832H4.60582L7.09703 3H13.2142C15.1498 3 16.5316 3.4043 17.2064 4.16406C17.5249 4.53441 17.7471 4.97767 17.8531 5.4545C17.9592 5.93133 17.9458 6.42696 17.8143 6.8974L17.7957 7.00964C17.7835 7.08612 17.7725 7.16083 17.7523 7.25586C17.5594 8.68478 16.8453 9.99202 15.7472 10.9264C14.5143 11.7837 13.0285 12.2005 11.5296 12.1094H9.7064C9.25618 12.1079 8.82037 12.268 8.47825 12.5607C8.13612 12.8533 7.9104 13.2591 7.84215 13.7041ZM19.3509 11.2988C18.8001 14.127 17.1087 15.4443 14.0287 15.4443H13.5453C13.1259 15.4411 12.719 15.5876 12.398 15.8576C12.0771 16.1276 11.8629 16.5032 11.7943 16.917L11.1449 20.9912L8.71715 21L9.1953 17.9661L9.80644 14.1133H11.5257C11.6825 14.1133 11.8211 14.0897 11.9739 14.0843C12.3327 14.072 12.6905 14.0582 13.0265 14.0165C13.2318 13.9909 13.4201 13.9443 13.6169 13.9078C13.8894 13.8574 14.1621 13.8076 14.4179 13.7365C14.6083 13.6835 14.7859 13.6153 14.967 13.5509C15.2063 13.466 15.4418 13.3769 15.6646 13.2722C15.8326 13.1931 15.9927 13.1052 16.1512 13.0149C16.3622 12.8954 16.5666 12.7647 16.7635 12.6232C16.9058 12.5206 17.0454 12.4153 17.1785 12.3022C17.3672 12.1396 17.5465 11.9663 17.7155 11.7833C17.8285 11.6628 17.9442 11.5458 18.0488 11.4161C18.2224 11.1949 18.3826 10.9636 18.5288 10.7234C18.6052 10.6012 18.69 10.4882 18.7604 10.3596C18.963 9.98894 19.137 9.6034 19.2811 9.20634C19.2898 9.18248 19.3022 9.16234 19.3107 9.13834C19.3147 9.12711 19.3206 9.11777 19.3245 9.10648C19.5227 9.8227 19.5318 10.5781 19.3509 11.2988Z" fill="currentColor" />
                    <path d="M20.4369 7.10449C20.2642 6.91091 20.0723 6.7354 19.8641 6.58069C19.9495 5.91079 19.8905 5.23035 19.6908 4.58522C19.4911 3.9401 19.1554 3.34527 18.7064 2.84082C17.6224 1.61914 15.7748 1 13.2142 1H7.00035C6.55143 1.0012 6.11755 1.16195 5.77623 1.45354C5.43491 1.74514 5.20836 2.14858 5.13707 2.5918L2.54722 18.9981C2.51058 19.218 2.52233 19.4432 2.58167 19.6581C2.64101 19.873 2.74649 20.0724 2.89078 20.2423C3.03507 20.4123 3.21468 20.5487 3.4171 20.6421C3.61952 20.7355 3.83988 20.7837 4.06282 20.7832H6.72691L6.64491 21.3037C6.61175 21.5131 6.62436 21.7272 6.68189 21.9312C6.73941 22.1352 6.84047 22.3244 6.97811 22.4856C7.11576 22.6468 7.28671 22.7763 7.4792 22.8651C7.67168 22.9539 7.88113 22.9999 8.09312 23H11.3275C11.7465 23.0033 12.1529 22.8572 12.4739 22.5878C12.7948 22.3185 13.0092 21.9435 13.0785 21.5303L13.7191 17.499L13.7299 17.4443H14.0287C18.0609 17.4443 20.5795 15.4512 21.3139 11.6816C21.5379 10.9035 21.5752 10.0835 21.4229 9.28817C21.2705 8.49287 20.9327 7.74472 20.4369 7.10449ZM7.84215 13.7041L7.12767 18.2394L7.04136 18.7832H4.60582L7.09703 3H13.2142C15.1498 3 16.5316 3.4043 17.2064 4.16406C17.5249 4.53441 17.7471 4.97767 17.8531 5.4545C17.9592 5.93133 17.9458 6.42696 17.8143 6.8974L17.7957 7.00964C17.7835 7.08612 17.7725 7.16083 17.7523 7.25586C17.5594 8.68478 16.8453 9.99202 15.7472 10.9264C14.5143 11.7837 13.0285 12.2005 11.5296 12.1094H9.7064C9.25618 12.1079 8.82037 12.268 8.47825 12.5607C8.13612 12.8533 7.9104 13.2591 7.84215 13.7041ZM19.3509 11.2988C18.8001 14.127 17.1087 15.4443 14.0287 15.4443H13.5453C13.1259 15.4411 12.719 15.5876 12.398 15.8576C12.0771 16.1276 11.8629 16.5032 11.7943 16.917L11.1449 20.9912L8.71715 21L9.1953 17.9661L9.80644 14.1133H11.5257C11.6825 14.1133 11.8211 14.0897 11.9739 14.0843C12.3327 14.072 12.6905 14.0582 13.0265 14.0165C13.2318 13.9909 13.4201 13.9443 13.6169 13.9078C13.8894 13.8574 14.1621 13.8076 14.4179 13.7365C14.6083 13.6835 14.7859 13.6153 14.967 13.5509C15.2063 13.466 15.4418 13.3769 15.6646 13.2722C15.8326 13.1931 15.9927 13.1052 16.1512 13.0149C16.3622 12.8954 16.5666 12.7647 16.7635 12.6232C16.9058 12.5206 17.0454 12.4153 17.1785 12.3022C17.3672 12.1396 17.5465 11.9663 17.7155 11.7833C17.8285 11.6628 17.9442 11.5458 18.0488 11.4161C18.2224 11.1949 18.3826 10.9636 18.5288 10.7234C18.6052 10.6012 18.69 10.4882 18.7604 10.3596C18.963 9.98894 19.137 9.6034 19.2811 9.20634C19.2898 9.18248 19.3022 9.16234 19.3107 9.13834C19.3147 9.12711 19.3206 9.11777 19.3245 9.10648C19.5227 9.8227 19.5318 10.5781 19.3509 11.2988Z" fill="black" fill-opacity="0.06" />
                  </g>
                  <defs>
                    <clipPath id="clip0_2088_125">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </div>
            </span>
          </div>

          <hr className="border-[#E5E7EB]" />
          <div className="mt-[24px] text-center flex-wrap text-[#6B7280] text-[16px] ">A currency exchange rate of <span className="font-medium text-[#C1A875]">24,000 VND/USD</span> will be applied to USD payments through international credit and debit cards.</div>
        </div>

        <div className="mt-[80px] sm:w-[555px] text-[#404654] font-[Inter] text-[16px] leading-[24px] section-all-bank">
          <div className="mb-[32px] text-center flex-wrap">We accept all major payment gateways and support local bank transfers.</div>
          <div className="list-online flex justify-center gap-[36px] mb-[24px] flex-wrap">
            <div className="one-item">
              <img src="/bank/onl1.png" alt="" />
            </div>
            <div className="one-item">
              <img src="/bank/onl2.png" alt="" />
            </div>
            <div className="one-item">
              <img src="/bank/onl3.png" alt="" />
            </div>
            <div className="one-item">
              <img src="/bank/onl4.png" alt="" />
            </div>
            <div className="one-item">
              <img src="/bank/onl5.png" alt="" />
            </div>
            <div className="one-item">
              <img src="/bank/onl6.png" alt="" />
            </div>
          </div>
          <div className="list-online flex justify-center gap-[16px] mb-[48px] flex-wrap">
            <div className="one-item">
              <img src="/bank/bank1.png" alt="" />
            </div>
            <div className="one-item">
              <img src="/bank/bank2.png" alt="" />
            </div>
            <div className="one-item">
              <img src="/bank/bank3.png" alt="" />
            </div>
            <div className="one-item">
              <img src="/bank/bank4.png" alt="" />
            </div>
            <div className="one-item">
              <img src="/bank/bank5.png" alt="" />
            </div>
            <div className="one-item">
              <img src="/bank/bank6.png" alt="" />
            </div>
          </div>
          <div className="flex gap-[8px] justify-center mb-[24px] flex-wrap">
            <span>All payments are processed securely through</span>
            <img width="auto" height="auto" style={{ objectFit: 'contain' }} src="/bank/one-pay.png" alt="" />
          </div>
          <div className="flex gap-[8px] justify-center mb-[24px]">
            <img width="auto" height="auto" style={{ objectFit: 'contain' }} src="/bank/three-image.png" alt="" />
          </div>
        </div>

        <AntModal
          open={open}
          footer={null}
          centered
          closable={false}
          onCancel={() => setOpen(false)}
          width={320}
          bodyStyle={{ textAlign: "center" }}
        >
          <div className="flex flex-col items-center gap-[24px]">
            <div className="flex items-center justify-center">
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_2076_3332)">
                  <path d="M20.0002 3.3335C10.8002 3.3335 3.3335 10.8002 3.3335 20.0002C3.3335 29.2002 10.8002 36.6668 20.0002 36.6668C29.2002 36.6668 36.6668 29.2002 36.6668 20.0002C36.6668 10.8002 29.2002 3.3335 20.0002 3.3335ZM20.0002 33.3335C12.6502 33.3335 6.66683 27.3502 6.66683 20.0002C6.66683 12.6502 12.6502 6.66683 20.0002 6.66683C27.3502 6.66683 33.3335 12.6502 33.3335 20.0002C33.3335 27.3502 27.3502 33.3335 20.0002 33.3335ZM27.6502 12.6335L16.6668 23.6168L12.3502 19.3168L10.0002 21.6668L16.6668 28.3335L30.0002 15.0002L27.6502 12.6335Z" fill="#B0976E" />
                  <path d="M20.0002 3.3335C10.8002 3.3335 3.3335 10.8002 3.3335 20.0002C3.3335 29.2002 10.8002 36.6668 20.0002 36.6668C29.2002 36.6668 36.6668 29.2002 36.6668 20.0002C36.6668 10.8002 29.2002 3.3335 20.0002 3.3335ZM20.0002 33.3335C12.6502 33.3335 6.66683 27.3502 6.66683 20.0002C6.66683 12.6502 12.6502 6.66683 20.0002 6.66683C27.3502 6.66683 33.3335 12.6502 33.3335 20.0002C33.3335 27.3502 27.3502 33.3335 20.0002 33.3335ZM27.6502 12.6335L16.6668 23.6168L12.3502 19.3168L10.0002 21.6668L16.6668 28.3335L30.0002 15.0002L27.6502 12.6335Z" fill="white" fill-opacity="0.12" />
                </g>
                <defs>
                  <clipPath id="clip0_2076_3332">
                    <rect width="40" height="40" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <h2 className="text-lg font-medium text-gray-900 mb-1">
              Order successful!
            </h2>
            <p className="text-gray-600 mb-6 text-sm">
              Thank you for your purchase of our Premium Plus plan.
            </p>
            <div
              onClick={handleHomepage}
              className="w-full h-[40px] bg-btn-border-C1A875-cl-C1A875 transition duration-300 flex justify-center items-center"
            >
              Homepage
            </div>
          </div>
        </AntModal>
      </div>
    </Layout>
  )
}
export default Dashboard